import { formatPrice } from 'lib/util'

export const getters = {
  subtotal (state) {
    return formatPrice(state.app.cart.total_price)
  },

  subscriptions (state) {
    return state.app.cart.items.filter(({ properties = {} }) => {
      return properties ? properties.subscription_id : null
    })
  },

  purchases (state) {
    return state.app.cart.items.filter(({ properties = {} }) => {
      return properties ? !properties.subscription_id : true
    })
  },

  purchasesTotal (state, getters) {
    return getters.purchases.reduce((total, item) => {
      return total + item.line_price
    }, 0)
  },

  subscriptionTotal (state, getters) {
    return getters.subscriptions.reduce((total, item) => {
      return total + item.line_price
    }, 0)
  },

  giftMessage (state) {
    return state.app.cart.note
  },

  giftMessageEdited (state) {
    return state.giftMessageEdited
  },

  bundles (state) {
    const bundles = {}
    state.app.cart.items.forEach((item) => {
      if (item.properties && item.properties['bundle_id']) {
        if (!bundles[item.properties['bundle_id']]) {
          bundles[item.properties['bundle_id']] = []
        }
        bundles[item.properties['bundle_id']].push(item)
      }
    })
    return bundles
  }
}
